export default {
  EMERGENCY_TITLE:
    'Do not schedule appointments online if you are experiencing any of these symptoms. If any of these apply, go to the Emergency Room or call 911.',
  SYMPTOMS: [
    'Severe allergic reaction',
    'Broken bone with an obvious deformity',
    'Burns of any size',
    'Chest Pain',
    'Head or neck injury',
    'Heavy bleeding',
    'Infant less than 2 weeks with any concerns',
    'The patient is 0-3 months old with a fever of 100.4 or greater',
    'Injury or trauma to eye',
    'Severe lacerations or cuts (anything that may require stitches or worse)',
    'Loss of consciousness/passed out or fainted',
    'Opening of surgical wound',
    'Possible stroke',
    'Potential harm to self or others',
    'Pregnancy with a recent history of trauma',
    'Pregnancy and has vaginal bleeding or abdominal pain',
    'Severe abdominal pain',
    'Severe shortness of breath/difficulty breathing',
    'Unable to keep down liquids for 24 hours, because of vomiting',
    'Vomiting Blood, blood in stool, or black stool',
    'Falls, especially elderly and very young/on blood thinners/children who fall 2-3 times their height'
  ]
};
